<div class="dashboard-container">
  <div class="ms-2">
      <NavigationBackButton />
  </div>
  <div class="rounded-3">
    <div class="d-flex justify-content-between align-items-center ms-2 mb-3">

      <!-- LEFT: TEXT -->
      <div>
        <p class="text-xl fw-bold fst-italic p-0 m-0">
          Welcome Back , {{ currently_logged_in }} !
        </p>
        <p class="text-x p-0 m-0 fw-600">
          Explore More Opportunities
        </p>
      </div>

      <!-- RIGHT: BUTTON -->
      <button
        class="btn-primary-dark btn-sm rounded-small shadow text-dark text-xs"
        @click="redirect_to_my_jobs"
      >
        <i class="bi bi-briefcase fs-6 me-1"></i>
        View My Jobs
      </button>

    </div>
    
    <!-- FILTER SECTION -->
    <section class="mb-4">
      <div class="glassy-table shadow-sm rounded-lg p-3 p-md-4 bg-gradient">

        <!-- Mobile Toggle Buttons -->
        <div class="d-flex justify-content-between align-items-center mb-2 d-md-none">
          <button
            class="btn btn-sm btn-primary-dark"
            @click="showFilters = !showFilters"
          >
            {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
          </button>

        </div>


        <!-- Header -->
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 gap-2">
          
          <div>
            <p class="fw-bold mb-1 text-x text-white">Filter Jobs</p>
            <p class="text-white text-xs mb-0 ">
              Select a programme and refine your search to find the right opportunity.
            </p>
          </div>

          <!-- Desktop Clear Button -->
          <button
            type="button"
            class="nav-link me-2 text-xxs btn btn-sm btn-primary-dark rounded-small d-none d-md-inline-block"
            @click="clear_filters"
          >
            Clear Filters
          </button>
        </div>

        <!-- Filters (Collapsible on Mobile) -->
        <div :class="['filters-container', { 'd-none d-md-block': !showFilters }]">
          <div class="row g-3">

            <div class="col-12 col-md-6 col-lg-2">
              <label class="form-label text-xs fw-600 mb-1 text-white">Programmes</label>
              <select class="form-select form-select-sm text-xxs border-0 shadow-sm"
                v-model="filters.programmeId"
                @change="on_filter_change">
                <option value="">All Programmes</option>
                <option v-for="programme in programme_options"
                        :key="programme.value"
                        :value="programme.value">
                  {{ programme.label }}
                </option>
              </select>
            </div> 

            <div class="col-12 col-md-6 col-lg-2">
              <label class="form-label text-xs fw-600 mb-1 text-white">Status</label>
              <select class="form-select form-select-sm text-xxs border-0 shadow-sm"
                v-model="filters.status"
                @change="on_filter_change">
                <option v-for="status in status_options"
                        :key="status.value || 'all-statuses'"
                        :value="status.value">
                  {{ status.label }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6 col-lg-2">
              <label class="form-label text-xs fw-600 mb-1 text-white">Sort By</label>
              <select class="form-select form-select-sm text-xxs border-0 shadow-sm"
                v-model="filters.sortBy"
                @change="on_filter_change">
                <option value="recent">Most Recent</option>
                <option value="closing">Closing Date</option>
                <option value="title">Job Title</option>
              </select>
            </div>

            <div class="col-12 col-md-6 col-lg-2">
              <label class="form-label text-xs fw-600 mb-1 text-white">Search</label>
              <input
                v-model="filters.search"
                type="text"
                class="form-control form-control-sm text-xxs border-0 shadow-sm"
                placeholder="Title or ref #"
                @input="on_filter_change"
              >
            </div>

          </div>

          <div class="d-flex justify-content-end mt-3">
            <span class="status-badge text-dark border bg-white rounded-lg px-3 py-2 fw-600">
              {{ filtered_jobs.length }} job(s) found
            </span>
          </div>
        </div>

      </div>
    </section>

    <!-- Job Listings -->
    <section>
      <div class="row row-cols-1 row-cols-md-2 g-3">
        <div v-for="(job, index) in paginated_jobs"
             :key="job.id || `job-${index}`"
             class="col">

          <div class="glassy-table job-card h-100 shadow-lg rounded-lg p-3 d-flex flex-row align-items-center gap-3">

            <div class="d-flex align-items-center justify-content-center bg-success rounded-circle text-white job-icon p-1">
              <i class="bi bi-briefcase-fill fs-6"></i>
            </div>

            <div class="flex-grow-1">
              <div class="d-flex justify-content-between align-items-start gap-2">
                <span class="fw-bold fw-600 text-x">{{ job.jobTitle }}</span>
                
              </div>

              <p class="text-dark text-xs mb-0 mt-1 gap-2">
                <span v-if="job.referenceNumber && job.referenceNumber !== '-'">
                  Ref: {{ job.referenceNumber }} &bull;
                </span>

                <i class="bi bi-calendar-event me-1"></i>

                <span v-if="job.publishedDate" class="fw-600">
                  Opens : {{ format_display_datetime(job.publishedDate) }}
                </span>
                <span v-else>Opens: TBD</span>

                <span class="mx-1">&ndash;</span>

                <span v-if="job.closingDate" class="fw-600">
                  Closes : {{ format_display_datetime(job.closingDate) }}
                </span>
                <span v-else>Open-ended</span>
              </p>
            </div>
            <div class="d-flex flex-column align-items-end gap-3">

              <!-- STATUS (TOP) -->
              <span
                class="status-badge text-dark fw-bold"
                :class="get_status_badge_class(job.status)"
              >
                {{ job.status }}
              </span>

              <!-- BUTTON (BOTTOM) -->
              <button
                class="btn btn-primary btn-sm text-xxs view-details-btn"
                data-bs-toggle="modal"
                data-bs-target="#job-details-modal"
                @click="open_job_details(job)"
              >
                View Details
              </button>

            </div>

          </div>
        </div>
      </div>
    </section>

    <!-- Pagination -->
    <div v-if="total_pages > 1" class="d-flex justify-content-center align-items-center mt-4 mb-3">
      <div class="d-flex gap-1">
        <button
          class="btn btn-primary btn-sm text-xxs view-details-btn"
          :disabled="current_page === 1"
          @click="go_to_page(current_page - 1)"
        >
          &lt;
        </button>
        <button
          class="btn btn-primary btn-sm text-xxs view-details-btn"
          :disabled="current_page === total_pages"
          @click="go_to_page(current_page + 1)"
        >
          &gt;
        </button>
      </div>
    </div>

  </div>

  <AICampusFooter />
</div>

<!-- Job Details Modal -->
<teleport to="body">
  <div class="modal fade" id="job-details-modal" tabindex="-1" aria-labelledby="job_details_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <!-- Modal Header (cute-header like manage_questions) -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <div class="flex-grow-1">
            <p class="modal-title text-white text-xxs mb-0" id="job_details_label">{{ job_profile.title || job.title }}</p>
            <small class="text-white-50 text-xxs d-flex align-items-center flex-wrap gap-1" v-if="job.publishedDate || job.closingDate">
              <i class="bi bi-calendar-event"></i>
              <span v-if="job.publishedDate">{{ format_display_datetime(job.publishedDate) }}</span>
              <span v-else>TBD</span>
              <span class="mx-1">to</span>
              <i class="bi bi-calendar-event"></i>
              <span v-if="job.closingDate">{{ format_display_datetime(job.closingDate) }}</span>
              <span v-else>Open-ended</span>
            </small>
          </div>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body (scrollable) -->
        <div class="modal-body p-4">

          <!-- Loading State -->
          <div v-if="loading_profile" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3 text-muted text-xxs">Loading job profile...</p>
          </div>

          <!-- Loaded Content (mirrors ViewJobProfile VIEW mode) -->
          <div v-else-if="job_profile.display_blocks && job_profile.display_blocks.length">

            <div v-for="(block, bidx) in job_profile.display_blocks" :key="block.key || bidx" class="job-detail-block">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-green-gov-dark rounded-50 me-2 d-flex align-items-center justify-content-center circle-badge-28">
                  {{ section_badge_label(block.title) }}
                </span>
                <h6 class="fw-bold mb-0 text-xs">{{ section_display_title(block.title) }}</h6>
              </div>

              <div v-if="block.kind === 'details'" class="text-xxs text-dark rich-text-content" v-html="clean_html(block.data)"></div>

              <template v-else>
                <div v-if="block.data.table && block.data.table.rows && block.data.table.rows.length > 0 && has_table_content(block.data)"
                     class="table-responsive mb-3">
                  <table class="table table-bordered table-hover table-sm align-middle">
                    <thead class="table-light">
                      <tr>
                        <th v-for="(hdr, hIdx) in block.data.table.headers"
                            :key="'mh-'+hIdx"
                            class="fw-semibold text-xxs text-uppercase">
                          {{ typeof hdr === 'object' ? hdr.label : hdr }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, rIdx) in block.data.table.rows" :key="'mr-'+rIdx">
                        <td v-for="(cell, cIdx) in row"
                            :key="'mc-'+cIdx"
                            class="text-xxs rich-text-content"
                            v-html="clean_html(cell)">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else-if="block.data.descriptions && block.data.descriptions.length">
                  <div v-for="(desc, dIdx) in block.data.descriptions"
                       :key="'md-'+dIdx"
                       class="mb-2 text-xxs text-dark rich-text-content"
                       v-html="clean_html(desc)">
                  </div>
                </div>

                <div v-else-if="block.data.content" class="text-xxs text-dark rich-text-content" v-html="clean_html(block.data.content)"></div>

                <div v-else class="text-dark text-xxs fst-italic">
                  <i class="bi bi-info-circle me-1"></i>
                  No content available for this section.
                </div>

                <div v-if="block.data.subsections && block.data.subsections.length" class="mt-3 ps-3 border-start">
                  <div v-for="(subsection, subIdx) in block.data.subsections"
                       :key="'job-sub-'+subIdx"
                       v-show="subsection.show_on_advert !== false"
                       class="mb-3 p-3 bg-light rounded-3">
                    <h6 class="fw-semibold mb-2 text-xs">
                      {{ subsection.title || ('Sub-section ' + (subIdx + 1)) }}
                    </h6>

                    <div v-if="subsection.table && subsection.table.rows && subsection.table.rows.length > 0 && has_table_content(subsection)"
                         class="table-responsive mb-2">
                      <table class="table table-bordered table-hover table-sm align-middle">
                        <thead class="table-light">
                          <tr>
                            <th v-for="(hdr, hIdx) in subsection.table.headers"
                                :key="'msh-'+hIdx"
                                class="fw-semibold text-xxs text-uppercase">
                              {{ typeof hdr === 'object' ? hdr.label : hdr }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, rIdx) in subsection.table.rows" :key="'msr-'+rIdx">
                            <td v-for="(cell, cIdx) in row"
                                :key="'msc-'+cIdx"
                                class="text-xxs rich-text-content"
                                v-html="clean_html(cell)">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="subsection.descriptions && subsection.descriptions.length">
                      <div v-for="(desc, dIdx) in subsection.descriptions"
                           :key="'msd-'+dIdx"
                           class="mb-2 text-xxs text-dark rich-text-content"
                           v-html="clean_html(desc)">
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

          </div>

          <!-- Fallback: No profile data -->
          <div v-else class="text-center py-5">
            <i class="bi bi-file-earmark-x fs-1 text-muted mb-3 d-block"></i>
            <p class="text-muted text-xxs mb-0">No advert data available for this position.</p>
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-sm rounded-small text-xxs shadow px-3"
            :class="job.alreadyApplied ? 'btn-secondary text-white' : 'btn-primary-dark text-dark'"
            :disabled="job.alreadyApplied || (job.status === 'Closed' && job.applicationState !== 'archived')"
            @click="applyForJob"
          >
            {{ get_job_action_label(job) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>
